module.exports = __webpack_public_path__ + "static/media/hat-china.2ee73f73.png";